export default __webpack_public_path__ + "static/media/icacii.4db4534d.png";